<template>
    <div class="dashboard">
        <!-- Page header -->
        <div class="dash-header">
            <div>
                <h1>{{ $t('menu.overview.page.header') }}</h1>
                <p class="dash-subtitle">{{ $t('menu.overview.page.subtitle') }}</p>
            </div>
        </div>

        <!-- Stat cards -->
        <div class="dash-stats">
            <div class="tap-card tap-stat" style="animation-delay: 0.05s;">
                <div class="stat-accent" style="background: #a63c3c;"></div>
                <i class="bx bx-map-pin tap-stat-icon"></i>
                <div class="tap-stat-value">{{ user.stores.length }}</div>
                <div class="tap-stat-label">{{ $t('menu.overview.page.storeLocator.header') }}</div>
            </div>

            <div class="tap-card tap-stat" style="animation-delay: 0.1s;">
                <div class="stat-accent" style="background: #F7CB15;"></div>
                <i class="bx bx-store tap-stat-icon" style="color: rgba(247, 203, 21, 0.25);"></i>
                <div class="tap-stat-value">{{ storeStatusNewCount }}</div>
                <div class="tap-stat-label">{{ $t('menu.overview.page.newStores') }}</div>
            </div>

            <div class="tap-card tap-stat" style="animation-delay: 0.15s;">
                <div class="stat-accent" style="background: #ED6A5A;"></div>
                <i class="bx bx-globe tap-stat-icon" style="color: rgba(237, 106, 90, 0.25);"></i>
                <div class="tap-stat-value">{{ languageCount }}</div>
                <div class="tap-stat-label">{{ $t('menu.overview.page.activeMarkets') }}</div>
            </div>

            <div class="tap-card tap-stat" style="animation-delay: 0.2s;">
                <div class="stat-accent" style="background: #7e5bef;"></div>
                <i class="bx bx-group tap-stat-icon" style="color: rgba(126, 91, 239, 0.25);"></i>
                <div class="tap-stat-value">{{ user.users.length || '—' }}</div>
                <div class="tap-stat-label">{{ $t('menu.overview.page.teamMembers') }}</div>
            </div>
        </div>

        <!-- Quick nav -->
        <h3 class="dash-section-title">{{ $t('menu.overview.page.quickAccess') }}</h3>
        <div class="dash-quicknav">
            <div class="tap-hub-card" @click="$router.push('/store-locator')" style="animation-delay: 0.25s;">
                <div class="hub-icon"><i class="bx bx-map-pin"></i></div>
                <div class="hub-title">{{ $t('menu.overview.page.storeLocator.header') }}</div>
                <div class="hub-desc">{{ $t('menu.overview.page.storeLocator.text') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>
            <div class="tap-hub-card" @click="$router.push('/pim')" style="animation-delay: 0.3s;">
                <div class="hub-icon" style="background: rgba(247, 203, 21, 0.1); border-color: rgba(247, 203, 21, 0.15);">
                    <i class="bx bx-package" style="color: #F7CB15;"></i>
                </div>
                <div class="hub-title">{{ $t('menu.overview.page.productInformation') }}</div>
                <div class="hub-desc">{{ $t('menu.overview.page.productInformationDesc') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>
            <div class="tap-hub-card" @click="$router.push('/translations')" style="animation-delay: 0.35s;">
                <div class="hub-icon" style="background: rgba(237, 106, 90, 0.1); border-color: rgba(237, 106, 90, 0.15);">
                    <i class="bx bx-globe-alt" style="color: #ED6A5A;"></i>
                </div>
                <div class="hub-title">{{ $t('menu.overview.page.translations') }}</div>
                <div class="hub-desc">{{ $t('menu.overview.page.translationsDesc') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();
        return { user }
    },
    computed: {
        storeStatusNewCount() {
            return this.user.storeStatusNew ? this.user.storeStatusNew.length : 0;
        },
        languageCount() {
            if (!this.user.translations || !this.user.translations.userLangs) return '—';
            return Object.values(this.user.translations.userLangs).filter(l => l.visible).length;
        }
    },
    methods: {
        navigate(item) {
            this.user.editInvoice = item;
            this.user.getInvoiceData();
            this.$router.push({ name: 'edit-invoice' });
        },
        formatDate(date) {
            const today = new Date(date);
            return today.toLocaleDateString("da-DK", {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        },
        formatStatus(status) {
            switch (status) {
                case '1':
                    return this.$t('menu.overview.page.status_new');
                case '2':
                    return this.$t('menu.overview.page.status_in_progress');
                case '3':
                    return this.$t('menu.overview.page.status_done');
                default:
                    return this.$t('menu.overview.page.status_unknown');
            }
        }
    }
}
</script>

<style scoped>
.dashboard {
}

.dash-header {
    margin-bottom: 1.75rem;
}
.dash-subtitle {
    color: #9aa0a8;
    font-size: 0.875rem;
    margin-top: 0.125rem;
}

.dash-stats {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1rem;
    margin-bottom: 2.5rem;
}
.dash-stats .tap-stat {
    animation: slideUp 0.5s ease-out both;
}

.stat-accent {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    border-radius: 2px 2px 0 0;
    opacity: 0.6;
}

.dash-section-title {
    margin-bottom: 1rem;
}

.dash-quicknav {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1rem;
}
.dash-quicknav .tap-hub-card {
    animation: slideUp 0.5s ease-out both;
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
}
</style>
